import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import HolidayMenu from "./pages/HolidayMenu";
import Seasonings from "@/pages/Seasonings";
import Catering from "@/pages/Catering";
import Events from "@/pages/Events";
import SmallTownShowdown from "@/pages/SmallTownShowdown";
import Locations from "@/pages/Locations";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Owner from "@/pages/Owner";
import Lenis from "lenis";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { CartProvider } from "./lib/CartContext";
import CartDrawer from "./components/CartDrawer";

const PAYPAL_OPTIONS = {
  "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: "USD",
  intent: "capture",
  components: "buttons",
  "disable-funding": "paylater,credit,card",
};

// Reset scroll position to top on every route change (works with Lenis smooth scroll)
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true, force: true });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <PayPalScriptProvider options={PAYPAL_OPTIONS}>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <CartDrawer />
          <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/holiday-menu" element={<HolidayMenu />} />
            <Route path="/seasonings" element={<Seasonings />} />
            <Route path="/catering" element={<Catering />} />
            <Route path="/events" element={<Events />} />
            <Route path="/small-town-showdown" element={<SmallTownShowdown />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<Blog />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/owner" element={<Owner />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </CartProvider>
    </PayPalScriptProvider>
  );
}

export default App;
